























































































































import SurveyCard from '@/components/SurveyCard.vue';
import SendButton from '@/components/Form/SendButton.vue';
import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import LogEvent from '@/services/LogEvent';
import JourneyParameters from '@/models/interfaces/JourneyParameters';
import Instance from '@/models/interfaces/Instance';
import SoluCXService from '@/services/SolucxService';
import AccentStyleCreator from '@/services/AccentStyleCreator';
import LoadingView from '@/Views/LoadingView.vue';
import { setLanguage } from '@/assets/lang/I18n';
import { applyDocumentLanguage } from '@/services/Setupi18n';
import SoluCXFooter from '@/components/SoluCXFooter.vue';

@Component({ components: { LoadingView, SurveyCard, SendButton, SoluCXFooter } })
export default class Unsubscribe extends Vue {
  @Inject()
  private soluCXService: SoluCXService;

  private instance: Instance;
  private sending: boolean = false;
  private loading: boolean = true;
  private log: LogEvent;
  private contact: string;
  private channel: string;
  private transactionId: string;
  private error: string = null;
  private reason: string = null;
  private reasonProvided = false;

  public async mounted() {
    const lang: string = !!this.$route.query.lang !== false ? this.$route.query.lang.toString() : '';
    this.$root.$i18n.locale = setLanguage(lang);
    applyDocumentLanguage();
    this.log = new LogEvent();

    const params = this.$router.currentRoute.params;
    this.contact = params.email || params.phone;
    const channel = this.$router.currentRoute.query.channel;
    this.channel = Array.isArray(channel) ? channel[0] : channel;

    const transactionIdParam = this.$router.currentRoute.query.transactionId;
    this.transactionId = Array.isArray(transactionIdParam) ? transactionIdParam[0] : transactionIdParam;

    await this.getConfig();
    this.log.setInstance(this.instance.slug);
  }

  public async unsubscribe() {
    try {
      await this.soluCXService.unsubscribe(this.contact, this.transactionId, this.channel);
      this.reasonProvided = true;
      this.log.unsubscribeReason(this.reason);
    } catch (error) {
      this.log.error('unsubscribe error');
      this.error = error?.response?.data?.errors;
    }
  }

  private async getConfig() {
    // Load config and updates view
    this.loading = true;
    this.instance = await this.soluCXService.getJourneyParameters();
    AccentStyleCreator.createAccentColorStyle(this.instance.color_main);
    this.loading = false;
  }
}
